module.exports = __webpack_public_path__ + "img/cms-for-mobile-code.47c659b6.png";